import { type FC, useContext } from 'react';
import { ServerVarsContext } from '../../sharedComponents/ServerVarsContext';
import { Carousel } from 'dibs-carousel';

import styles from './DesignSeriesHeroImages.scss';

type Props = {
    seriesName: string;
    imageUrls: Array<string>;
};

const Image: FC<{ imageSrc: string | null | undefined; seriesName: string }> = ({
    imageSrc,
    seriesName,
}) =>
    imageSrc ? (
        <div className={styles.imageContainer}>
            <img className={styles.image} src={imageSrc} alt={seriesName} />
        </div>
    ) : null;

export const DesignSeriesHeroImages: FC<Props> = props => {
    const { imageUrls, seriesName } = props;
    const { isMobile } = useContext(ServerVarsContext);

    if (isMobile) {
        return (
            <div className="primary-viewport-width">
                <Carousel
                    dataTn="design-series-hero-image-carousel"
                    showDots={imageUrls.length > 1}
                    hideArrows
                    totalItems={imageUrls.length}
                    slideCarouselItems
                    renderItem={({ index }: { index: number }) => {
                        const imageSrc = imageUrls[index];
                        return <Image imageSrc={imageSrc} seriesName={seriesName} key={imageSrc} />;
                    }}
                />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.imageSpacer} />
            <div className={styles.images} data-tn="design-series-images-container">
                {imageUrls.map(imageSrc => (
                    <Image imageSrc={imageSrc} seriesName={seriesName} key={imageSrc} />
                ))}
            </div>
        </div>
    );
};
